import styled from "@emotion/styled";
import Head from "next/head";
import React from "react";
import ResultCounter from "@components-pages/agencies-agents-list/results-counter";
import Search from "@components-pages/agencies-agents-list/search";
import ListSection, {
  ListSectionInterface,
} from "@components-pages/agencies-agents-list/List-section";
import { useState } from "react";
import { useTranslations } from "next-intl";
import { TitleThickThin } from "@components/titles";

import type { GetStaticPropsContext, NextPage } from "next";
import createCanonicalUrl from "@helpers/removeparams";
import { useRouter } from "next/router";
import WsSectionTitleWithThinTitle from "@components/a1-refactor/typography/WsSectionTitleWithThinTitle copy";
import WsPhantomNav from "@components/a1-refactor/typography/WsPhantomNav";
const AgentesCollection: NextPage = () => {
  const titleT = useTranslations("title-pages");

  const translation = useTranslations("collection.certifiedAgents");
  const agentTitle = translation("title") || "";

  const [titleOne, titleTwo, ...rest] = agentTitle.split(" ");
  const [search, setSearch] = useState<string>("");
  const [count, setCount] = useState<number>(0);

  const router = useRouter();
  const config: ListSectionInterface = {
    active: 2,
    setCount,
    search,
    isCollection: true,
  };

  const metas = {
    title: titleT("collectionAgents"),
    meta: "Remax Royal, Agente inmobiliario, Agentes inmobiliarios, Agentes Remax, Remax metropolitana, Remax plus, Agente Remax plus, Agencias inmobiliaria, Agentes Remax República Dominicana",
  };
  return (
    <>
      <Head>
        <title>{metas.title}</title>
        <meta name="keywords" content={metas.meta} />
        <link
          rel="canonical"
          href={createCanonicalUrl(
            `${process.env.NEXT_PUBLIC_DOMAIN_URL}${router.asPath}`
          )}
          key="canonical"
        />
      </Head>

      <ArticleRoot>
        <section className="search">
          {/* <TitleThickThin
            component="h1"
            thinTitle={rest.join(" ")}
            thickTitle={`${titleOne} ${titleTwo}`}
          ></TitleThickThin> */}
          <WsSectionTitleWithThinTitle
            title={rest.join(" ")}
            subtitle={`${titleOne} ${titleTwo}`}
          ></WsSectionTitleWithThinTitle>
          <div className="container">
            <ContainerSearch className="container_title">
              <Search active={2} setSearch={setSearch}></Search>
            </ContainerSearch>
          </div>
        </section>
      </ArticleRoot>
      <ResultCounter active={2} count={count} />
      <ListSection {...config} />
    </>
  );
};

export default AgentesCollection;

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      locale,
      messages: (await import(`@lang/${locale}.json`)).default,
    },
  };
}

const Title = styled.h1`
  font-size: 18px;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  margin-bottom: 40px;
  color: var(--color-brand-blue-main);
`;
const ArticleRoot = styled.article`
  & .search {
    padding: 55px 0 30px;
  }
  @media screen and (max-width: 1299px) {
    & .search {
      padding-bottom: 50px;
    }
  }
  @media screen and (max-width: 500px) {
    padding-top: 100px;
    & .search {
      padding: 25px 0 30px;
    }
  }
`;

const ContainerSearch = styled.div`
  &.container_title {
    display: flex;
    flex-direction: column;
    width: 60%;
    margin: auto;
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    margin-top: 15px;
    font-size: 14px;
    font-family: var(--font-family);
    color: var(--color-brand-blue-main);

    .search_input {
      border: 1px solid #ccc !important;
    }

    @media screen and (max-width: 1000px) {
      width: 80%;
    }
    @media screen and (max-width: 1000px) {
      width: 100%;
      padding: 0px 20px;
    }
    @media screen and (max-width: 475px) {
      padding: 0px 10px;
    }
  }
`;
